// userSelectors.js

export const selectLoading = (state) => state.forgotPassword.loading;
export const selectRedirectUrl = (state) => state.forgotPassword.url;